<template>
    <div class="md-layout text-center">
        <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
            <login-card class=" pt-4">
                <md-field slot="inputs" class="mt-4 form-group label-floating">
                    <md-input v-model="email" type="email" class="form-control" :readonly="working" ref="emailField"></md-input>
                    <label class="control-label">{{$t('labels.email')}}</label>
                </md-field>
                <md-field slot="inputs" class="form-group label-floating">
                    <md-input v-model="password" class="form-control" type="password" :readonly="working" ref="passwordField"></md-input>
                    <label class="control-label">{{$t('labels.password')}}</label>
                </md-field>

                <template slot="footer">
                    <div class="flex-column">
                <md-button  v-on:click="login" class="md-success md-lg md-block" :disabled="working">
                    {{$t('buttons.login')}}
                </md-button>

                <md-button v-on:click="forgot" class="md-black md-lg md-simple md-block" :disabled="working">
                    {{$t('buttons.resetpassword')}}
                </md-button>
                    </div>
                </template>

                <md-progress-bar v-show="working" md-mode="indeterminate"    class="md-accent"
                                     slot="spinner"/>
            </login-card>
        </div>
    </div>
</template>
<script>
    import { LoginCard } from "@/components";
    import store from "../../../store";
    import apiService from "../../../services/APIService"
    import { mapGetters } from 'vuex'
    import StorageService from "../../../services/StorageService";

    export default {
        components: {
            LoginCard
        },
        data() {
            return {
                working: false,
                email: "",
                password: ""
            };
        },
        computed: {
            ...mapGetters(["activeAccount", "user"])
        },
        methods: {
            forgot(){
              this.$router.push({name:"Forgot"});  
            },
            login() {
                if(this.email === "" || this.password === "")
                    return;
                
                this.working = true;
                apiService.postApi("/auth/v1/token", { Email: this.email.trim(), Password: this.password.trim() }).then(response => {
                    this.working = false;
                    store.commit("SET_TOKEN", response.data);
                    StorageService.setItem('mys_token', store.state.userToken);
                    store.dispatch('loadUser').then(r => {
                       
                        if(!this.user.roles || this.user.roles.length === 0)
                        {
                            this.$router.push({ path: "/orders/myorders"});
                        } else {
                            store.commit("SET_ACCOUNT", this.user.roles[0]);
                        }
                        if(this.activeAccount && this.activeAccount.mys_account) {
                            const path = `/${this.activeAccount.mys_account}/shipping/upcoming`;
                            this.$router.push({ path });
                        }
                        else
                        {
                            store.commit("SET_ACCOUNT", this.user.roles[0]);
                            this.$router.push({ name: "Dashboard", params: { accountId: this.user.roles[0].mys_account } });
                        }
                     
                    });

                }).catch(error => {
                    this.working = false;
                    alert("FEJL VED LOGIN!(" + error.response.status + " " + error.response.statusText + ")\n\nDet er ikke længere muligt at bruge ordrenummer som password.\nKlik på SEND MIG ET PASSWORD for at få et nyt.");
                });

            }
        }
    };
</script>

<style lang="scss" scoped>
    .md-progress-spinner {
        margin: 15px;
    }

</style>
